import Keycloak from 'keycloak-js';

export const createKeycloakConnection = (authType, orgId) => {
  return new Keycloak({
    url: authType.provider,
    realm: orgId,
    clientId: authType.clientId
  });
};
